/**
 * 模組頁面代碼 : 1430-UI-02
 * 頁面說明 : 新增/編輯指派條件畫面
 * @module web/modules/condition/components/ConditionModal
 */

// ----- import from npm modules ----
import $ from 'jquery';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

// ----- import from local modules -----
import enumList from 'web/utils/enumList';
const {
  addCondition,
  editCondition,
} = require('web/redux/actions/ConditionActions');

// ----- constants -----
import {TITLE_CONDITION_NEW, TITLE_CONDITION_EDIT} from 'web/constant';
import {showMessage} from 'web/utils/modalHelper';
import {useSelector} from 'react-redux';

const ConditionModal = React.forwardRef((props, ref) => {
  const {onAddCondition, mode, setNeedEmployeeLoad} = props;
  const dispatch = useDispatch();
  const currentSelect = useSelector(
    (state) => state.condition?.conditionSelection?.data,
  )[0];

  const [formValues, setFormValues] = useState({
    modalConditionCode: '',
    modalConditionName: '',
    modalConditionDescription: '',
  });
  const [invalidShow, setInvalidShow] = useState('none');
  const modalIcon = mode === enumList.modalMode.new ? '#ico-plus' : '#ico-edit';
  const modalTitleText =
    mode === enumList.modalMode.new
      ? TITLE_CONDITION_NEW
      : TITLE_CONDITION_EDIT;

  useEffect(() => {
    if (mode === enumList.modalMode.edit && currentSelect) {
      setFormValues({
        modalConditionCode: currentSelect.conditionCode,
        modalConditionName: currentSelect.conditionName,
        modalConditionDescription: currentSelect.description,
      });
    }
  }, [mode, currentSelect]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    // 檢查表單是否驗證通過
    if (form.checkValidity() === false) {
      setInvalidShow('block');
      return;
    }
    form.classList.add('was-validated');

    const req = {
      conditionCode: formValues.modalConditionCode,
      conditionName: formValues.modalConditionName,
      description: formValues.modalConditionDescription,
    };

    if (mode === enumList.modalMode.new) {
      submitAddCondition(req);
    } else if (mode === enumList.modalMode.edit) {
      submitEditCondition(req);
    }
    form.classList.remove('was-validated');
    resetForm();
    setNeedEmployeeLoad(true);
  };

  const submitEditCondition = async (req) => {
    const result = await dispatch(editCondition(req)).unwrap();
    if (result.code.isSuccessCode()) {
      onAddCondition();
    } else {
      onAddCondition();
      showMessage(
        enumList.messageModalMode.error,
        'error',
        res.payload.message,
      );
    }
  };

  const submitAddCondition = (req) => {
    dispatch(addCondition(req)).then((res) => {
      const statusCode = res.payload.code;
      if (statusCode && statusCode.isSuccessCode()) {
        onAddCondition();
      } else {
        onAddCondition();
        showMessage(
          enumList.messageModalMode.error,
          'error',
          res.payload.message,
        );

        console.error('fetchDepartmentList error', res);
      }
    });
  };
  //   const submitEditCondition = (req) => {
  //     dispatch(editDepartment(req)).then((res) => {
  //       const statusCode = res.payload.code;
  //       if (statusCode && statusCode.isSuccessCode()) {
  //         const departmentList = res.payload.result;
  //         reloadPositionList();
  //       } else {
  //         // toggleDepartmentEditModal(false);
  //         showMessage(enumList.messageModalMode.error, 'error', res.payload.message);
  //       }
  //     });
  //   };

  // Handle change event
  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;

    setFormValues({
      ...formValues,
      [target.name]: value,
    });
  };

  const resetForm = () => {
    setFormValues({
      modalConditionCode: '',
      modalConditionName: '',
      modalConditionDescription: '',
    });
  };

  return (
    <div
      ref={ref}
      className="modal fade"
      id="modelCondition"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="modalConditionLabel"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <form
          className="modal__form modal-content needs-validation"
          id="modalAccountForm"
          noValidate
          onSubmit={handleSubmit}
        >
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="modalAccountLabel">
              <div className="modal__title__badge">
                <svg className="badge__icon" aria-hidden="true">
                  <use href={modalIcon}></use>
                </svg>
              </div>
              <div className="modal__title__text">{modalTitleText}</div>
            </h1>
            <button
              type="button"
              className="btn-close btn-cancel"
              data-bs-dismiss="modal"
              onClick={() => setTimeout(resetForm, 500)}
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column gap-3 px-2">
              <div className="modal__form__catagory row">
                <div className="col-3">
                  <div className="modal__form__catagory__lable">
                    指派條件資訊
                  </div>
                </div>
                <div className="col-9">
                  <div className="row">
                    {/* <div className="col-6">
                      <label htmlFor="modalConditionCode" className="form-label">
                        條件代號*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalConditionCode"
                        name="modalConditionCode"
                        value={formValues.modalConditionCode}
                        onChange={handleChange}
                        required
                      />
                    </div> */}
                    <div className="col-12">
                      <label
                        htmlFor="modalConditionName"
                        className="form-label"
                      >
                        條件名稱*
                      </label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        id="modalConditionName"
                        name="modalConditionName"
                        value={formValues.modalConditionName || ''}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-12">
                      <label
                        htmlFor="modalConditionDescription"
                        className="form-label"
                      >
                        條件描述
                      </label>
                      <textarea
                        className="form-control"
                        id="modalConditionDescription"
                        name="modalConditionDescription"
                        value={formValues.modalConditionDescription || ''}
                        onChange={handleChange}
                        rows="2"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div
                    className="alert alert-warning global-invalid-feedback"
                    style={{display: invalidShow}}
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => setTimeout(resetForm, 500)}
              className="btn btn-cancel"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              儲存
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export default ConditionModal;
